<template>
  <div class="p-the-page-ab01 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <div class="c-common-inner">
        <main class="p-the-page-ab01__loginpanel">
          <div class="p-the-page-ab01__loginpanel__inner">
            <div class="p-the-page-ab01__service_logo__wrap">
              <p>当該サービスは現在ご利用いただけません。</p>
            </div>
          </div>
        </main>
      </div>
    </div>
    <TheFooter />
  </div>
</template>
<script lang="ts">
import { gsap } from "gsap";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import TextLink from "@/common/components/atoms/TextLink.vue";
import ServiceLogo from "@/common/components/atoms/ServiceLogo.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import IconEyeInvisible from "@/common/components/icons/IconEyeInvisible.vue";
import IconEyeVisible from "@/common/components/icons/IconEyeVisible.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import { mapState } from "vuex";
import { getContractInfos } from "@/general/store/api";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheFooter,
    InputText,
    ButtonMain,
    TextLink,
    ServiceLogo,
    IconBase,
    IconArrowBottom,
    IconEyeInvisible,
    IconEyeVisible,
    ValidationErrorText
  },
  computed: {
    ...mapState({
      colorCode: () => commons.OrgPageSpecific?.page_color
    })
  }
})
export default class NotContractedIc extends Vue {
  loginAuthentication: any = false;

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    this.loginAuthentication = true;
    LocalStorage.setItem("NotContractedIc", "1");
  }
}
</script>
<style lang="scss" scoped>
.p-the-page-ab01 {
  background-color: $common-white;

  &__service_logo {
    width: px(320);

    @include sp {
      width: px(140);
    }

    &__wrap {
      display: flex;
      justify-content: center;
    }
  }

  &__message {
    margin-top: rem(40);
    border-top: px(1) solid $common-gray-border;
    border-bottom: px(1) solid $common-gray-border;

    @include sp {
      margin-top: rem(36);
    }

    &__hidden {
      overflow: hidden;
    }

    &__text {
      font-size: px(16);
      padding: 0 rem(24) rem(18) rem(24);

      @include sp {
        padding: 0 rem(14) rem(11) rem(14);
      }
    }

    &__button {
      width: 100%;
      padding: rem(19) rem(24) rem(18) rem(24);
      display: flex;
      align-items: center;

      @include sp {
        padding: rem(12) rem(14) rem(11) rem(14);
      }

      &__text {
        font-size: rem(16);
        font-weight: bold;

        @include sp {
          font-size: rem(14);
        }
      }
      &__icon {
        margin: 0 0 0 auto;
        line-height: 0;
      }
    }
  }

  &__login_authentication {
    margin-top: rem(56);
    display: flex;
    justify-content: center;

    &__text {
      font-size: px(14);
    }
  }

  &__loginpanel {
    width: 100%;
    max-width: rem(576);
    margin: auto;
    padding: rem(120) 0 rem(128) 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    @include sp {
      padding: rem(48) 0 rem(40) 0;
    }

    &__inner {
      width: 100%;
      margin: auto;
    }
  }

  &__form {
    margin-top: rem(40);

    @include sp {
      margin-top: rem(24);
    }
  }

  &__button {
    width: rem(288);

    &__wrap {
      margin-top: rem(40);
      display: flex;
      justify-content: center;
    }
  }

  &__blank {
    margin-right: 2em;
  }

  &__button_submit {
    width: rem(288);

    &__wrap {
      margin-top: rem(40);
      max-width: 20em;
      display: flex;
      justify-content: center;
      margin: auto;
      margin-top: rem(40);
      width: 50%;
    }
  }
  &__link_forgot {
    font-size: rem(14);

    &__wrap {
      margin-top: rem(36);
      display: flex;
      justify-content: center;
    }
  }
}
</style>
